import { GeocodingFeature } from '../../../common/types/mapbox-search-api-v1.types.ts';

export interface ItemDetailsState {
  activeItem: GeocodingFeature | null;
  activeItemIndex: number | null;
  activeItemDatasource: string | null;
}

export enum ItemDetailsActionTypes {
  ACTIVE_ITEM_CHANGED = 'item-details/active-item-changed',
}

export interface ActionActiveItemChanged {
  type: ItemDetailsActionTypes.ACTIVE_ITEM_CHANGED;
  item: GeocodingFeature | null;
  index?: number | null;
  datasource?: string | null;
}

export type ItemDetailsAction = ActionActiveItemChanged;
